<template>
  <ToggleSwitch
    v-model="adminMode"
    @change="changeAdminMode"
    name="admin-mode-switch"
  />
</template>
<script lang="ts">
import { useSessionStore } from '@/stores/SessionStore.ts';
import HardReload from '@/presentation/mixins/HardReload.js';

export default {
  name: 'admin-mode-switch',
  mixins: [HardReload],
  data() {
    return {
      adminMode: null,
    };
  },
  mounted() {
    this.adminMode = useSessionStore().adminMode;
  },
  methods: {
    changeAdminMode() {
      useSessionStore().setAdminMode(this.adminMode);
      this.reload();
    },
  },
};
</script>
